import { TOOL_DIRECTORY } from "../app/toolDirectory";
import { readCommunityPurpose, type CommunityPurpose } from "./communityParticipation";

const escapeHtml = (value: string) => value.replace(/[&<>"']/g, (char) =>
  ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[char]!);

/** Only public directory metadata is copied, never the current item's URL or data. */
export function communityToolDraft(route: string | null, intent: string | null) {
  const tool = TOOL_DIRECTORY.find((item) => item.route === route && item.section !== "account");
  const purpose = readCommunityPurpose(intent);
  if (!tool || (purpose !== "question" && purpose !== "story")) return null;
  const questions = purpose === "question"
    ? ["어떤 기능을 사용하다 궁금해졌나요?", "현재 상황과 시도해 본 방법", "어떤 도움이 필요한가요?"]
    : ["어떤 수업·업무에 활용했나요?", "이렇게 사용했어요", "좋았던 점과 다른 선생님께 전할 팁"];
  return {
    tool,
    purpose: purpose as CommunityPurpose,
    title: `[${tool.name}] `,
    placeholder: purpose === "question" ? `[${tool.name}] 궁금한 점을 한 문장으로 적어주세요` : `[${tool.name}] 나누고 싶은 활용 경험을 적어주세요`,
    html: `<blockquote class="fe-community-tool-card"><p>함께 나누는 도구</p><p><strong>${escapeHtml(tool.name)}</strong></p><p><a href="${escapeHtml(tool.route)}">도구 바로가기 →</a></p></blockquote>`
      + questions.map((question) => `<p><strong>${question}</strong></p><p><br></p>`).join(""),
    draftKey: `community-draft-tool-${tool.route}-${purpose}`,
  };
}
